import { createContext, useContext, useState } from 'react';
import '../styles/Alert.css'

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = ({ type = 'info', message = '', duration = 4000 }) => {
    const id = Date.now();
    setAlerts((prev) => [...prev, { id, type, message }]);

    // Auto-dismiss after `duration`
    setTimeout(() => {
      setAlerts((prev) => prev.filter(alert => alert.id !== id));
    }, duration);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <div className="global-alert-container">
        {alerts.map((alert) => (
          <div key={alert.id} className={`alert alert-${alert.type}`}>
            {alert.message}
          </div>
        ))}
      </div>
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
